<div
  class="side-bar-container pe-1"
  id="side-bar-container"
  [style.top]="sidebarTop >= 0 ? sidebarTop + 'px' : undefined"
  [class.showControls]="showControls"
  [hidden]="!sideBarActive"
  >
  <div class="px-2 px-sm-0 selected-filter-list">
    <ng-content></ng-content>
    @if (
      (selectedFilterList && selectedFilterList.length) || commonFilterSet
      ) {
      <div
        class="d-grid mt-1"
        >
        <button
          type="button"
          class="btn btn-dark btn-block my-1"
          id="removeFilters"
          data-dismiss="alert"
          aria-label="Close"
          (click)="removeFilters(true)"
          >
          {{ "REMOVE_FILTERS" | translate }}
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    }
    @if (selectedFilterList.length) {
      <ul class="list-unstyled mb-0">
        @for (filter of selectedFilterList; track filter; let i = $index) {
          @if (!filter.long_list) {
            <li
              class="clickable withOpacity border-bottom py-1 text-primary d-flex justify-content-between align-items-start"
              (click)="removeFilter(filter, i)"
        ><span innerHTML="&middot; {{ filter.name }}:  {{
          filter.description
        }}"></span><span class="rounded text-center delete-filter" style="width: 24px">&times;</span>
            </li>
          }
          @if (filter.long_list) {
            <li
              class="clickable withOpacity border-bottom py-1 text-primary"
              (click)="viewFilter(filter)"
              >
              &middot; {{ filter.name }}: {{ filter.description }}
              <button class="d-inline btn btn-sm btn-primary py-0 px-1">
                {{ "VIEW" | translate }}
                @if (filter.count > 0) {
                  ({{ filter.count }})
                }
              </button>
            </li>
          }
        }
      </ul>
    }
    <small class="d-flex align-items-center card my-1 p-1 justify-content-end clickable withOpacity " (click)="saveFilters()">
      <span
        class="d-flex align-items-center load_filters"
        >
        {{ "SAVE_LOAD_FILTERS" | translate }}</span
        ></small
        >
      </div>

      <div class="filters" [ngClass]="!sideBarActive ? 'inActive' : ''">
        <div class="mb-3 filter-group">
          <app-search-filter #searchFilter
            (filter)="filterWithKeyword.emit($event)"
          ></app-search-filter>
        </div>
        <div class="mb-3 filter-group">
          <app-groups-tree
            [groups]="groups"
            (groupSelected)="groupSelected($event)"
          ></app-groups-tree>
        </div>
        <div class="mb-3 filter-group">
          <div
            [class.collapsed]="priceCollapsed"
            >
            <label
              class="filterHeader clickable withOpacity w-100"
              (click)="priceCollapsed = !priceCollapsed; priceInit = true"
              >{{ "RETAILPRICE" | translate }}</label
              >
              @if ((!priceCollapsed && !priceInit) || priceInit) {
                <div class="d-flex align-items-center flex-column">
                  <ngx-slider
                    class="custom-slider d-block"
                    [(value)]="minValue"
                    [(highValue)]="maxValue"
                    [(options)]="options"
                    (userChangeEnd)="onUserChange($event)"
                    [hidden]="priceCollapsed"
                  ></ngx-slider>
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <input
                      type="number"
                      class="form-control me-2 price-filter"
                      style="width: 90px;"
                      [min]="minValue"
                      [max]="maxValue"
                      [(ngModel)]="priceManualMinValue"
                      (keyup)="onManualPriceChange($event,{ value: priceManualMinValue, highValue: priceManualMaxValue })"
                      [hidden]="priceCollapsed"
                      />
                    <span>&mdash;</span>
                    <input
                      type="number"
                      class="form-control ms-2 price-filter"
                      style="width: 90px;"
                      [min]="minValue"
                      [max]="maxValue"
                      [(ngModel)]="priceManualMaxValue"
                      (keyup)="onManualPriceChange($event,{ value: priceManualMinValue, highValue: priceManualMaxValue })"
                      [hidden]="priceCollapsed"
                      />
                  </div>
                </div>
              }
            </div>
          </div>
          @if (
            !selectedFilters['COMMON']['CMN_IN_STOCK'] &&
            showStockFilter &&
            showGeneralFilters
            ) {
            <div
              class="mb-3 filter-group"
              >
              <div
                [class.collapsed]="deliveryWeekCollapsed"
                >
                <label
                  class="filterHeader clickable withOpacity w-100"
          (click)="
            deliveryWeekCollapsed = !deliveryWeekCollapsed;
            deliveryWeekInit = true
          "
                  >{{ "DELIVERY_WEEK" | translate }}</label
                  >
                  @if (
                    (!deliveryWeekCollapsed && deliveryWeekInit) || deliveryWeekInit
                    ) {
                    <app-stockweek-filter
                      class="d-block"
                      (change)="stockweekRangeChange($event)"
                      [stockweekFilter]="stockweekData"
                      [hidden]="deliveryWeekCollapsed"
                    ></app-stockweek-filter>
                  }
                </div>
              </div>
            }
            @if (showGeneralFilters) {
              <div class="mb-3 filter-group">
                <label class="filterHeader">{{ "SELECTION" | translate }}</label>
             
                @if (applicationService.getSelectCompanyGroupCode() !== 'COM') {
                  <app-common-filter
                    [name]="'CMN_AVAIL'"
                    [translation]="'AVAILABLE'"
                    [selectedValue]="selectedFilters['COMMON']['CMN_AVAIL']"
        (updated)="
          getCommonFilter($event);
          track('Available', selectedFilters['COMMON']['CMN_AVAIL'])
        "
                  ></app-common-filter>
                }
                <app-common-filter
                  [name]="'CMN_IN_STOCK'"
                  [translation]="'STATUS12'"
                  [selectedValue]="selectedFilters['COMMON']['CMN_IN_STOCK']"
        (updated)="
          getCommonFilter($event);
          track('In stock', selectedFilters['COMMON']['CMN_IN_STOCK']);
          resetStock()
        "
                ></app-common-filter>
                <app-common-filter
                  [name]="'CMN_NEW'"
                  [translation]="'NEW'"
                  [selectedValue]="selectedFilters['COMMON']['CMN_NEW']"
                  (updated)="getCommonFilter($event)"
                ></app-common-filter>
                <app-common-filter
                  [name]="'CMN_PROM'"
                  [translation]="'PROMOTION'"
                  [selectedValue]="selectedFilters['COMMON']['CMN_PROM']"
        (updated)="
          getCommonFilter($event);
          track('Promotions', selectedFilters['COMMON']['CMN_PROM'])
        "
                ></app-common-filter>
                <app-common-filter
                  [name]="'TOP_PERFORMER'"
                  [translation]="'TOP_PERFORMERS'"
                  [selectedValue]="selectedFilters['COMMON']['TOP_PERFORMER']"
                  *ngIf="applicationService.getSelectCompanyGroupCode() !== 'COM'"
                  (updated)="getCommonFilter($event)"
                ></app-common-filter>
                 <app-common-filter
                  [name]="'MUST_STOCK_LIST_FILTER'"
                  *ngIf="showMustStockListFilter"
                  [translation]="'MUST_STOCK_LIST'"
                  [selectedValue]="selectedFilters['COMMON']['MUST_STOCK_LIST_FILTER']"
                  (updated)="getCommonFilter($event)"
                ></app-common-filter>
                <app-common-filter
                  [name]="'CMN_OLD'"
                  [translation]="'SEARCHALLCOLLECTIONS'"
                  [selectedValue]="selectedFilters['COMMON']['CMN_OLD']"
        [ngClass]="
          selectedFilters['COMMON']['CMN_BOM'] === true ? 'disabled' : ''
        "
        (updated)="
          getCommonFilter($event);
          track('Old collection', selectedFilters['COMMON']['CMN_OLD'])
        "
                  >
                </app-common-filter>
                @if (hasBom) {
                  <app-common-filter
                    [name]="'CMN_BOM'"
                    [translation]="'SHOWBOM'"
                    [selectedValue]="selectedFilters['COMMON']['CMN_BOM']"
        (updated)="
          getCommonFilter($event);
          searchBomChange($event);
          track('Bom', selectedFilters['COMMON']['CMN_BOM'])
        "
                  ></app-common-filter>
                }
              </div>
            }
            <div class="mb-3 filter-group" >
              <div [class.collapsed]="collectionCollapsed">
                <label
                  class="filterHeader clickable withOpacity w-100"
                  (click)="collectionCollapsed = !collectionCollapsed"
                >{{ "COLLECTION" | translate }}</label>
                <app-collection-filter
                  [hidden]="collectionCollapsed"
                  [serviceEnabled]="selectedFilters['COMMON']['CMN_OLD']"
                  (collectionFilterChanged)="onCollectionFilterChange($event)"
                ></app-collection-filter>
              </div>
            </div>
            @if (
              selectedFilters['COMMON']['CMN_PROM'] && promotions && promotions.length
              ) {
              <div
                class="mb-3 filter-group"
                >
                <label class="filterHeader">{{ "PROMOTIONS" | translate }}</label>
                <select
                  class="form-control"
                  [(ngModel)]="promotionCode"
                  (change)="setPromotionCode($event)"
                  name="homepromo"
                  >
                  <option [value]="''">{{ "ALL" | translate }}</option>
                  @for (groupedPromotions of promotions; track groupedPromotions) {
                    @for (promotion of groupedPromotions; track promotion) {
                      <option
                        [value]="promotion.promotioncode + '_' + promotion.company_id"
            [innerHTML]="
              promotion.title === '' ? promotion.promotioncode : promotion.title
            "
                      ></option>
                    }
                  }
                </select>
              </div>
            }
            @if (availableFilters && availableFilters.length) {
              @for (filterGroup of availableFilters; track filterGroup.specification_code ?? $index) {
                @if (filterGroup.options?.length >= 1 && filterGroup.id !== 'Price') {
                  <div
                    class="mb-3 filter-group search-related"
                    [style.order]="filterGroup.rank"
                    [id]="'filter-' + filterGroup.specification_code"
                    >
                    <div
            [ngClass]="[
              !filterGroup.expanded && !filterKeywords ? 'compact' : 'expanded',
              filterGroup.collapse ? 'collapsed' : ''
            ]"
                      >
                      <label
                        class="filterHeader clickable withOpacity w-100"
                        (click)="toggleFilter(filterGroup)"
              [innerHTML]="
                filterGroup.name +
                ((filterGroup.collapse && !globalFilterKeyword)
                  ? ' (' + filterGroup['options'].length + ')'
                  : '')
              "
                        >
                      </label>
                      @if (filterGroup.is_slider && filterGroup.options?.length > 2) {
                        <div
                          class="d-block"
                          >
                          <app-range-filter [filter]="filterGroup"  [multiRange]="filterGroup.slider_type === 'Range'" (change)="selectedFilters[filterGroup?.specification_code] = $event; selectFilter()"></app-range-filter>
                        </div>
                      }
                      @if (
                        filterGroup.show_checkboxes ||
                        !filterGroup.is_slider ||
                        filterGroup.options?.length <= 2
                        ) {
                        <div
                          >
                          @if (filterGroup.options?.length >= 8) {
                            <app-search-filter-list
                (searching)="
                  filterList($event, filterGroup?.specification_code)
                "
                (triggerFilterSelection)="
                  selectFilters(
                    filterGroup,
                    filterGroup['options']
                  )
                "
                            ></app-search-filter-list>
                          }
                          <div class="form-check-container" [class.desktop]="!isMobile">
                            @if (isLetterGroupedFilter(filterGroup.specification_code)) {
                              @if (!letterGroupExpanded.has(filterGroup.specification_code)) {
                                @for (filter of (hasActiveSearch(filterGroup.specification_code) ? filterGroup['options'] : topByCount(filterGroup['options'])); track filter.id) {
                                  <div class="form-check" [ngClass]="filterGroup?.specification_code + '_' + filter['id']">
                                    @if (selectedFilters[filterGroup?.specification_code] && (matchesSearch(filterGroup, filter['description']) || selectedFilters[filterGroup?.specification_code][filter['id']])) {
                                      <input
                                        class="form-check-input"
                                        type="checkbox"
                                        value="{{ filter['id'] }}"
                                        (change)="track(filter['id'], selectedFilters[filterGroup?.specification_code][filter['id']]); selectFilter()"
                                        [name]="filter['id']"
                                        [checked]="selectedFilters[filterGroup['specification_code']][filter['id']]"
                                        [(ngModel)]="selectedFilters[filterGroup?.specification_code][filter['id']]"
                                        />
                                      <label
                                        class="form-check-label clickable withOpacity"
                                        (click)="selectedFilters[filterGroup?.specification_code][filter['id']] = !selectedFilters[filterGroup?.specification_code][filter['id']]; track(filter['id'], selectedFilters[filterGroup?.specification_code][filter['id']]); selectFilter()"
                                        [ngClass]="selectedFilters[filterGroup?.specification_code][filter['id']] ? 'selected' : ''"
                                        [innerHTML]="filter['description']"
                                        >
                                      </label>
                                    }
                                  </div>
                                }
                                @if (filterGroup['options'].length > 5) {
                                  <button class="btn btn-sm btn-block btn-outline-dark py-1 w-100 mt-1" (click)="toggleLetterGroup(filterGroup.specification_code)">
                                    {{ "SHOW_ALL_OPTIONS" | translate }} ({{ filterGroup['options'].length }})
                                  </button>
                                }
                              }
                              @if (letterGroupExpanded.has(filterGroup.specification_code)) {
                                @for (group of groupOptionsByLetter(filterGroup['options']); track group.letter) {
                                  <div class="aamrk-letter-group">
                                    <span class="aamrk-letter-header">{{ group.letter }}</span>
                                    @for (filter of group.items; track filter.id) {
                                      <div class="form-check" [ngClass]="filterGroup?.specification_code + '_' + filter['id']">
                                        @if (selectedFilters[filterGroup?.specification_code] && (matchesSearch(filterGroup, filter['description']) || selectedFilters[filterGroup?.specification_code][filter['id']])) {
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="{{ filter['id'] }}"
                                            (change)="track(filter['id'], selectedFilters[filterGroup?.specification_code][filter['id']]); selectFilter()"
                                            [name]="filter['id']"
                                            [checked]="selectedFilters[filterGroup['specification_code']][filter['id']]"
                                            [(ngModel)]="selectedFilters[filterGroup?.specification_code][filter['id']]"
                                            />
                                          <label
                                            class="form-check-label clickable withOpacity"
                                            (click)="selectedFilters[filterGroup?.specification_code][filter['id']] = !selectedFilters[filterGroup?.specification_code][filter['id']]; track(filter['id'], selectedFilters[filterGroup?.specification_code][filter['id']]); selectFilter()"
                                            [ngClass]="selectedFilters[filterGroup?.specification_code][filter['id']] ? 'selected' : ''"
                                            [innerHTML]="filter['description']"
                                            >
                                          </label>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                                <button class="btn btn-sm btn-block btn-outline-dark py-1 w-100 mt-1" (click)="toggleLetterGroup(filterGroup.specification_code)">
                                  {{ "SHOW_LESS" | translate }}
                                </button>
                              }
                            }
                            @if (!isLetterGroupedFilter(filterGroup.specification_code)) {
                              @for (filter of filterGroup['options']; track filterId(i, filter); let i = $index) {
                              @if (!filterGroup['max_items'] || (i <= filterGroup['max_items'] || filterGroup['show_all'])) {
                                <div
                                  class="form-check"
                                  [ngClass]="filterGroup?.specification_code + '_' + filter['id']"
                                  >
                                  @if (
                                    selectedFilters[filterGroup?.specification_code] &&
                                    (matchesSearch(
                                    filterGroup,
                                    filter['description']
                                    ) ||
                                    selectedFilters[filterGroup?.specification_code][
                                    filter['id']
                                    ])
                                    ) {
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      value="{{ filter['id'] }}"
                      (change)="
                        track(
                          filter['id'],
                          selectedFilters[filterGroup?.specification_code][
                            filter['id']
                          ]
                        );
                        selectFilter()
                      "
                                      [name]="filter['id']"
                      [checked]="
                        selectedFilters[filterGroup['specification_code']][
                          filter['id']
                        ]
                      "
                      [(ngModel)]="
                        selectedFilters[filterGroup?.specification_code][
                          filter['id']
                        ]
                      "
                                      />
                                    @if (filterGroup.specification_code === 'COLORBAS') {
                                      <span
                                        class="color-filter"
                                        [ngClass]="'color-' + filter['id']"
                                        >
                                      </span>
                                    }
                                    <label
                                      class="form-check-label clickable withOpacity"
                      (click)="
                        selectedFilters[filterGroup?.specification_code][
                          filter['id']
                        ] =
                          !selectedFilters[filterGroup?.specification_code][
                            filter['id']
                          ];
                        track(
                          filter['id'],
                          selectedFilters[filterGroup?.specification_code][
                            filter['id']
                          ]
                        );
                        selectFilter()
                      "
                      [ngClass]="
                        selectedFilters[filterGroup?.specification_code][
                          filter['id']
                        ]
                          ? 'selected'
                          : ''
                      "
                                      [innerHTML]="filter['description']"
                                      >
                                    </label>
                                  }
                                </div>
                              }
                            }
                            }
                            @if (filterGroup['options'].length > filterGroup['max_items'] && !isLetterGroupedFilter(filterGroup.specification_code)) {
                              <button class="btn btn-sm btn-block btn-outline-dark py-1 w-100"  (click)="toggleVisibleOptions(filterGroup)">{{(filterGroup['show_all'] ? "SHOW_LESS" : "SHOW_ALL_OPTIONS")|translate}} @if (!filterGroup.show_all) {
                                ({{filterGroup?.options?.length}})
                              }</button>
                            }
                          </div>
                          @if (filterGroup.is_slider && filterGroup.options?.length > 1) {
                            <div
                              class="w-full text-center"
                              >
                              <span
                                class="material-icons clickable withOpacity"
                                (click)="filterGroup.show_checkboxes = false"
                                >
                                expand_less
                              </span>
                            </div>
                          }
                        </div>
                      }
                      @if (
                        !filterGroup.show_checkboxes && filterGroup.options?.length > 2
                        ) {
                        <div
                          >
                          @if (filterGroup.is_slider) {
                            <div class="w-full text-center">
                              <span
                                class="material-icons clickable withOpacity"
                                (click)="filterGroup.show_checkboxes = true"
                                >
                                expand_more
                              </span>
                            </div>
                          }
                        </div>
                      }
                    </div>
                    @if (
                      filterGroup.options?.length > 14 &&
                      !filterGroup.collapse &&
                      !filterKeywords
                      ) {
                      <span
                        class="expand clickable withOpacity"
                        (click)="toggleFilter(filterGroup)"
                        >
                        <i class="material-icons">
                          {{
                          !filterGroup.expanded
                          ? "keyboard_arrow_down"
                          : "keyboard_arrow_up"
                          }}
                        </i>
                        {{ (!filterGroup.expanded ? "SEE_ALL" : "SEE_LESS") | translate }}
                      </span>
                    }
                  </div>
                }
                @if (
                  filterGroup.options?.length > 14 &&
                  !filterGroup.collapse &&
                  !filterKeywords
                  ) {
                  <span
                    class="expand clickable withOpacity"
                    (click)="toggleFilter(filterGroup)"
                    >
                    <i class="material-icons">
                      {{
                      !filterGroup.expanded
                      ? "keyboard_arrow_down"
                      : "keyboard_arrow_up"
                      }}
                    </i>
                    {{ (!filterGroup.expanded ? "SEE_ALL" : "SEE_LESS") | translate }}
                  </span>
                }
              }
            }
          </div>
          @if (showControls && applicationService.getSelectCompanyGroupCode() !== 'LAP') {
            @if (showControls && showModal) {
              <div class="position-fixed mx-auto shadow rounded border p-3" id="filterDialogContainer"  style="inset: 100px 0 auto 0; z-index: 99;" >
                <div class="container mb-5" style="overflow: auto; max-height: 700px; resize: vertical;">
                  <div class="row" (clickOutside)="showModal = false">
                    <div class="col-12">
                      <app-filter-dialog #filterDialog [availableFilters]="availableFilters" [selectedFilterList]="selectedFilterList" (filtersUpdated)="filtersUpdated.emit($event)" [numResults]="numResults" (showResults)="showModal = false"></app-filter-dialog>
                    </div>
                  </div>
                </div>
                <div class="position-absolute end-0 bottom-0 mb-2 me-3">
                  <div class="container">
                    @if (filterDialogCollapsed) {
                      <span class="me-2">{{availableFilters?.length}} {{"FILTERS" | translate}}</span>
                    }
                    <button class="btn btn-dark me-2" id="collapse-filters" [ngClass]="'filters-collapsed-' + filterDialogCollapsed" (click)="filterDialogCollapsed = !filterDialogCollapsed">{{ (!filterDialogCollapsed ? "COLLAPSE" : "EXPAND") | translate }}</button>
                    <button class="btn btn-primary" (click)="showModal = false">{{ "CLOSE" | translate }}</button>
                  </div>
                </div>
              </div>
            }
            <p-scrollTop target="parent" styleClass="custom-scrolltop" [threshold]="100" icon="pi pi-arrow-up"></p-scrollTop>
            <div class="position-fixed mx-0 d-none d-sm-flex ps-2" style="bottom: 87px; transform: translateX(30px)">
              @if (availableFilters?.length > 0) {
                <span class="btn btn-dark d-sm-flex align-items-center" (click)="showModal = !showModal; filterDialogCollapsed = false">
                  <i class="material-icons">filter_alt</i> ({{availableFilters?.length}})
                </span>
              }
            </div>
          }
        </div>
